import { createSelector } from 'reselect';

const stateSelector = state => state.snackbar;

export const notificationsSelector = createSelector(
  stateSelector,
  state => state.notifications
);
